module.exports = __webpack_public_path__ + "image/ecology_banner.jpg";